import React, { Component } from "react";
import { CSVLink } from "react-csv";
import ExportExcel from "./ExportExcelComponent";
//import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
//import Input from "@material-ui/core/Input";
//import InputAdornment from "@material-ui/core/InputAdornment";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import classNames from "classnames";
import { styles } from "../../assests/styles/DataTableStyle";
import { withStyles } from "@material-ui/core/styles";

class PrintSearchExport extends Component {
  exportParent = (boolValue) => {
    this.props.exportDataFunc(this.props.data, boolValue);
  };

  render() {
    const {
      status,
      classes,
      search,
      searchable,
      serachHandle,
      printTb,
      printHandle,
      exportAsExcel,
      data,
      exportHandle,
      mobileMoreAnchorEl,
      openMenu,
      onCloseMenu,
      radio,
      generate,
      //applExportbtn,
    } = this.props;
    let { exportData, header } = this.props;
    let filteredexportData =
      exportData.length > 0
        ? exportData.map(({ SOA, DOWNLOAD, Enroll, Select, ...rest }) => {
            return rest;
          })
        : "";
    if (Array.isArray(header)) {
      const index = header.findIndex((d) => {
        return d.title === "Action";
      });
      if (index !== -1) {
        header.splice(index, 1);
      }
    }
    let filteredheader = header.filter(
      (head) =>
        head.title != "SOA" &&
        head.title != "Enroll" &&
        head.title != "DOWNLOAD" &&
        head.title != "SOA PDF" &&
        head.title != "Application PDF" &&
        head.title !== "Select" &&
        head.title !== "PRE-ENROLLMENT FORM" &&
        head.title !== "COORDINATION OF CARE"
    );
    if (Array.isArray(filteredexportData)) {
      filteredexportData.forEach((d) => {
        if (d.hasOwnProperty("letterAvailabilityInDBGet")) {
          d.letterAvailabilityInDBGet = "PDF";
        }

        if (d.hasOwnProperty("letterAvailabilityInDBPdfIcon")) {
          d.letterAvailabilityInDBPdfIcon = "PDF";
        }
        if (d.hasOwnProperty("checkbox")) {
          delete d.checkbox;
        }
        // return d;
      });
    }

    return (
      <>
        <div className={classes.print}>
          <div class="text-right mb-2">
            {searchable ? (
              <span>
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  placeholder="Filter"
                  class="form-control width-12 height27 display-inline border-right-0 border-right-radius-0"
                  value={search}
                  onChange={serachHandle}
                />
                <button class="btn btn-primary2 border-left-0 border-left-radius-0 margin-top--1 search-btn">
                  <i class="material-icons">search</i>
                </button>
              </span>
            ) : null}
            <span
              className={
                "ml-3 display-inline-flex pt-1 " + classes.marginExport
              }
            >
              {exportAsExcel && data.length > 0 ? (
                <button
                  class="btn btn-secondary4 icon-export mr-2"
                  onClick={exportHandle}
                >
                  {" "}
                  <i class="fa fa-share-square-o" /> Export
                </button>
              ) : null}
            </span>
          </div>
          {/* {searchable ? (
            <FormControl className={classes.paddingSearch}>
              <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                id="input-with-icon-adornment"
                value={search}
                placeholder="Search..."
                className={classes.search}
                onChange={serachHandle}
                width={"220px"}
                startAdornment={
                  <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"Adornment position="start">
                    <i className="material-icons">search</i>
                  </InputAdornment>
                }
              />
            </FormControl>
          ) : null} */}

          <span>
            {printTb ? (
              <i class="material-icons icons-custome" onClick={printHandle}>
                print
              </i>
            ) : null}
          </span>
          {/* 
          <span className={classes.marginExport}>
            {exportAsExcel && data.length > 0 ? (
              <i
                onClick={exportHandle}
                className={classNames(
                  "fas fa-file-export",
                  applExportbtn ? classes.exportIconbtnAppl : classes.exportIcon
                )}
              />
            ) : exportAsExcel ? (
              <i
                className={classNames(
                  "fas fa-file-export",
                  applExportbtn ? classes.exportIconbtnAppl : classes.exportIcon
                )}
              />
            ) : null}
          </span> */}

          <Menu
            classes={{
              paper: classes.placing,
            }}
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={openMenu}
            onClose={onCloseMenu}
            style={{ zIndex: 2000 }}
          >
            <MenuItem>
              <RadioGroup row value={radio}>
                <FormControlLabel
                  value="current"
                  control={<Radio color="primary" />}
                  label="Current"
                  onClick={() => this.exportParent(false)}
                  style={{ marginLeft: "5px" }}
                />
                <FormControlLabel
                  value="all"
                  control={<Radio color="primary" />}
                  label="All"
                  onClick={() => this.exportParent(true)}
                />
              </RadioGroup>
            </MenuItem>
            <MenuItem className={classes.export}>
              <ExportExcel
                fileName={status ? status : "Document"}
                dataSet={filteredexportData}
                colName={filteredheader}
                classes={classes}
                closeMenu={onCloseMenu}
              />
              <CSVLink
                data={filteredexportData}
                headers={filteredheader}
                separator={","}
                filename={status ? status : "Document.csv"}
                onClick={onCloseMenu}
              >
                <i
                  className={classNames("fas fa-file-csv", classes.csvIcon)}
                ></i>
              </CSVLink>

              <i
                className={classNames("fa fa-file-pdf-o", classes.pdfIcon)}
                aria-hidden="true"
                onClick={() => generate(filteredexportData, filteredheader)}
              ></i>
            </MenuItem>
          </Menu>
        </div>
      </>
    );
  }
}
export default withStyles(styles)(PrintSearchExport);
